import React from "react";
import { QuestionnaireStatus } from "../../constants/Constants";


export interface SubmitLinkProps {
    onSubmit: () => void;
    status: string;
}

export class SubmitLink extends React.PureComponent<SubmitLinkProps> {

    render() {
        const { status, onSubmit } = this.props
        return <React.Fragment>
            {status === QuestionnaireStatus.Preview
                ? <span className="nav-link">Submit</span>
                : <a href="#!" className="nav-link" onClick={onSubmit}><span>Submit</span></a>}
        </React.Fragment>;
    }
}